import { Container } from './Container';

export function Footer() {
  return (
    <footer className="border-t border-slate-200 bg-white">
      <Container className="py-10">
        <div className="flex flex-col gap-6 sm:flex-row sm:items-center sm:justify-between">
          <div>
            <p className="text-sm font-semibold text-slate-900">Grow With Call</p>
            <p className="mt-1 text-sm text-slate-600">
              Business communication and customer engagement solutions.
            </p>
          </div>

          <nav className="flex items-center gap-6" aria-label="Footer">
            <a
              href="#/privacy"
              className="text-sm font-medium text-slate-700 hover:text-slate-900"
            >
              Privacy Policy
            </a>
            <a
              href="#/terms"
              className="text-sm font-medium text-slate-700 hover:text-slate-900"
            >
              Terms of Service
            </a>
          </nav>
        </div>

        <div className="mt-8 border-t border-slate-200 pt-6">
          <p className="text-xs text-slate-500">
            © {new Date().getFullYear()} Grow With Call. All rights reserved.
          </p>
        </div>
      </Container>
    </footer>
  );
}

